<template>
<div class="container">
<div class="get-started-steps section px-4 py-5">
      
    <div class="row justify-content-md-center">
      
      <div class="col-lg-6 text-center">
        <p class="lead">Let’s Get You Started!</p>
        <p class="lead">Please check your email for information on how to access the CSU Global Direct enrollment portal, and for instructions on how to enroll.</p>
<!--         
         <a href="https://portal.csuglobal.edu/site/index"><button class="btn btn-primary">Continue to Portal <i class="bi bi-arrow-right"></i></button></a>
         <router-link to="/#catalog"><button class="btn btn-outline-primary ms-3">Return To Catalog </button></router-link> -->
        
      </div><!--End Col-->
    </div><!--End Row-->



</div><!--end section-->
    </div><!--end container-->

</template>

<script>
export default {
    name: 'ConfirmationContent',
  props: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.btn-outline-primary:hover {
  color:#fff;
}

</style>
